import fetch from 'auth/FetchInterceptor'
import axios from 'axios'
import { API_BASE_URL } from 'configs/AppConfig'
import { AUTH_TOKEN, REFRESH_TOKEN } from 'constants/AuthConstant'

const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: '/auth/login',
		method: 'post',
		data,
	})
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data,
	})
}

AuthService.forgotPassword = function (data) {
	// Public endpoint — use raw axios so 401 interceptor is not involved.
	return axios.post(`${API_BASE_URL}/auth/forgot-password`, data).then((res) => res.data)
}

AuthService.resetPassword = function (data) {
	return axios.post(`${API_BASE_URL}/auth/reset-password`, data).then((res) => res.data)
}

AuthService.logout = function () {
	const refreshToken = localStorage.getItem(REFRESH_TOKEN)
	const token = localStorage.getItem(AUTH_TOKEN)
	if (!token) return Promise.resolve()
	return axios
		.post(
			`${API_BASE_URL}/auth/logout`,
			{ refreshToken },
			{ headers: { Authorization: `Bearer ${token}` } }
		)
		.catch(() => null)
}

export default AuthService
